import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { AppState, Auth0Provider, Auth0Context } from "@auth0/auth0-react";
import { Config } from "../../config";

export const AuthContextConsumer = Auth0Context.Consumer;

export const AuthProvider: FC = ({ children }) => {
  const { domain, clientId, audience } = Config.Auth0;
  if (domain === undefined || clientId === undefined || audience === undefined) {
    throw new Error("Authentication not configured");
  }

  const navigate = useNavigate();
  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || "/", { replace: true });
  };

  const isTestProduction = window.location.hostname === Config.testBaseUrl?.replace("https://", "");

  const auth0ClientId = isTestProduction ? Config.Auth0.clientIdTest : Config.Auth0.clientId;

  const auth0Domain = isTestProduction ? Config.Auth0.domainTest : Config.Auth0.domain;

  const auth0Audience = isTestProduction ? Config.Auth0.audienceTest : Config.Auth0.audience;

  const auth0LoginCallBackUri = isTestProduction
    ? Config.testBaseUrl + "/login"
    : Config.baseUrl + "/login";

  if (!auth0ClientId || !auth0Domain) {
    throw new Error("Auth0 client id or domain is not set");
  }

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      redirectUri={auth0LoginCallBackUri}
      audience={auth0Audience}
      scope={"openid profile name email"}
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="memory"
    >
      {children}
    </Auth0Provider>
  );
};
